import {
  SOURCE_QUALITY_EVALUATION_LOCATION,
  SOURCE_QUALITY_EVALUATION_RAW_MATERIAL,
  SOURCE_QUALITY_EVALUATION_RAW_MATERIAL_FOR_CREATE,
  SOURCE_QUALITY_EVALUATION_REQUEST_FORM,
  SOURCE_QUALITY_EVALUATION_TABLE_LOG,
  SOURCE_QUALITY_EVALUATION_DETAIL,
  SOURCE_QUALITY_EVALUATION_CREATE,
  SOURCE_QUALITY_EVALUATION_DELETE,
  SOURCE_QUALITY_EVALUATION_CALCULATE,
  SOURCE_QUALITY_EVALUATION_TEST_CENTER,
  SOURCE_QUALITY_EVALUATION_EXPORT_EXCEL,
  SOURCE_QUALITY_EVALUATION_EDIT,
  REMOVE_LISTS,
} from './actions'

const initialState = {
  // *load ข้อมูลต้นแหล่ง
  source_list: [],
  check_source_list: false,

  // *load ข้อมูลวัตถุดิบ
  material_list: [],
  check_material_list: false,

  // *table log ประเมินคุณภาพ
  check_table_log: false,
  table_log_list: [],
  table_log_total: 0,

  // *request form ประเมินคุณภาพ
  lists_request_form: [],
  check_request_form: false,

  // *detail ประเมินคุณภาพ
  lists_detail: [],
  check_detail: false,

  // *create form ประเมินคุณภาพ
  check_create: false,
  create_response: null,

  // *delete form
  check_delete: false,
  delete_response: null,

  // *calculate form
  check_calculate: false,
  lists_calculate: [],

  // *load ข้อมูลวัตถุดิบสำหรับหน้า create
  material_list_for_create: [],
  check_material_list_for_create: false,
  material_type_for_create: [],

  test_center: [],
  check_test_center_list: false,

  // *export excel
  source_quality_export_excel: {},
  check_source_quality_export_excel: false,

  // *edit form ประเมินคุณภาพ
  check_edit: false,
  edit_response: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState
    case SOURCE_QUALITY_EVALUATION_LOCATION.REQUEST:
      return {
        ...state,
        source_list: [],
        check_source_list: true,
      }
    case SOURCE_QUALITY_EVALUATION_LOCATION.SUCCESS:
      return {
        ...state,
        source_list: action.payload.lists.origin_location || [],
        check_source_list: false,
      }

    case SOURCE_QUALITY_EVALUATION_RAW_MATERIAL.REQUEST:
      return {
        ...state,
        material_list: [],
        check_material_list: true,
      }
    case SOURCE_QUALITY_EVALUATION_RAW_MATERIAL.SUCCESS:
      return {
        ...state,
        material_list: action.payload.lists.data || [],
        check_material_list: false,
      }

    case SOURCE_QUALITY_EVALUATION_RAW_MATERIAL_FOR_CREATE.REQUEST:
      return {
        ...state,
        material_list_for_create: [],
        material_type_for_create: [],
        check_material_list_for_create: true,
      }
    case SOURCE_QUALITY_EVALUATION_RAW_MATERIAL_FOR_CREATE.SUCCESS:
      return {
        ...state,
        material_list_for_create: action.payload.lists.data || [],
        material_type_for_create: action.payload.lists.material_type || [],
        check_material_list_for_create: false,
      }

    case SOURCE_QUALITY_EVALUATION_TABLE_LOG.REQUEST:
      return {
        ...state,
        check_table_log: true,
      }
    case SOURCE_QUALITY_EVALUATION_TABLE_LOG.SUCCESS:
      return {
        ...state,
        check_table_log: false,
        table_log_list: action.payload.lists.data || [],
        table_log_total: action.payload.lists.total || 0,
      }

    case SOURCE_QUALITY_EVALUATION_REQUEST_FORM.REQUEST:
      return {
        ...state,
        lists_request_form: [],
        check_request_form: true,
      }
    case SOURCE_QUALITY_EVALUATION_REQUEST_FORM.SUCCESS:
      return {
        ...state,
        lists_request_form: action.payload.lists,
        check_request_form: false,
      }

    case SOURCE_QUALITY_EVALUATION_DETAIL.REQUEST:
      return {
        ...state,
        lists_detail: [],
        check_detail: true,
      }
    case SOURCE_QUALITY_EVALUATION_DETAIL.SUCCESS:
      return {
        ...state,
        lists_detail: action.payload.lists,
        check_detail: false,
      }

    case SOURCE_QUALITY_EVALUATION_CREATE.REQUEST:
      return {
        ...state,
        check_create: true,
        create_response: null,
      }
    case SOURCE_QUALITY_EVALUATION_CREATE.SUCCESS:
      return {
        ...state,
        check_create: false,
        create_response: action.payload.lists,
      }

    case SOURCE_QUALITY_EVALUATION_DELETE.REQUEST:
      return {
        ...state,
        check_delete: true,
        delete_response: null,
      }
    case SOURCE_QUALITY_EVALUATION_DELETE.SUCCESS:
      return {
        ...state,
        check_delete: false,
        delete_response: action.payload.lists,
      }

    case SOURCE_QUALITY_EVALUATION_CALCULATE.REQUEST:
      return {
        ...state,
        lists_calculate: [],
        check_calculate: true,
      }
    case SOURCE_QUALITY_EVALUATION_CALCULATE.SUCCESS:
      return {
        ...state,
        lists_calculate: action.payload.lists,
        check_calculate: false,
      }

    case SOURCE_QUALITY_EVALUATION_TEST_CENTER.REQUEST:
      return {
        ...state,
        test_center_list: [],
        check_test_center_list: true,
      }
    case SOURCE_QUALITY_EVALUATION_TEST_CENTER.SUCCESS:
      return {
        ...state,
        test_center_list: action.payload.lists || [],
        check_test_center_list: false,
      }
    case SOURCE_QUALITY_EVALUATION_EXPORT_EXCEL.REQUEST:
      return {
        ...state,
        source_quality_export_excel: {},
        check_source_quality_export_excel: true,
      }
    case SOURCE_QUALITY_EVALUATION_EXPORT_EXCEL.SUCCESS:
      return {
        ...state,
        source_quality_export_excel: action.payload.lists || {},
        check_source_quality_export_excel: false,
      }
    case SOURCE_QUALITY_EVALUATION_EDIT.REQUEST:
      return {
        ...state,
        check_edit: true,
        edit_response: null,
      }
    case SOURCE_QUALITY_EVALUATION_EDIT.SUCCESS:
      return {
        ...state,
        check_edit: false,
        edit_response: action.payload.lists,
      }

    default:
      return state
  }
}
